module.exports = __webpack_public_path__ + "icon-file.7b0ace7.png";